<vw-toast-popup [isOpen]="isOpen" [title]="'garden.actions.title' | translate" (close)="onClose()">
  <div class="flex flex-col gap-3 px-4 pb-6">
    <!-- Ajouter une planche -->
    <button type="button" class="flex items-center gap-3 rounded-card border border-vw-line p-4 text-left" (click)="addBed()">
      <span class="flex h-11 w-11 items-center justify-center rounded-full bg-vw-surface-tint text-title-m">🟫</span>
      <span class="flex-1">
        <span class="block text-body font-semibold text-vw-ink">{{ 'garden.actions.add-bed.title' | translate }}</span>
        <span class="block text-caption text-vw-muted">{{ 'garden.actions.add-bed.subtitle' | translate }}</span>
      </span>
      <span class="text-vw-muted">›</span>
    </button>

    <!-- Planter une plante -->
    <button type="button" class="flex items-center gap-3 rounded-card border border-vw-line p-4 text-left" (click)="addPlant()">
      <span class="flex h-11 w-11 items-center justify-center rounded-full bg-vw-surface-tint text-title-m">🌱</span>
      <span class="flex-1">
        <span class="block text-body font-semibold text-vw-ink">{{ 'garden.actions.add-plant.title' | translate }}</span>
        <span class="block text-caption text-vw-muted">{{ 'garden.actions.add-plant.subtitle' | translate }}</span>
      </span>
      <span class="text-vw-muted">›</span>
    </button>

    <!-- Voir l'historique -->
    <button type="button" class="flex items-center gap-3 rounded-card border border-vw-line p-4 text-left" (click)="viewHistory()">
      <span class="flex h-11 w-11 items-center justify-center rounded-full bg-vw-surface-tint text-title-m">📜</span>
      <span class="flex-1">
        <span class="block text-body font-semibold text-vw-ink">{{ 'garden.actions.history.title' | translate }}</span>
        <span class="block text-caption text-vw-muted">{{ 'garden.actions.history.subtitle' | translate }}</span>
      </span>
      <span class="text-vw-muted">›</span>
    </button>

    <!-- Confier mon potager (NF-3) -->
    <button type="button" class="flex items-center gap-3 rounded-card border border-vw-line p-4 text-left" (click)="entrustGarden()"
      data-test="garden-action-handover">
      <span class="flex h-11 w-11 items-center justify-center rounded-full bg-vw-surface-tint text-title-m" aria-hidden="true">🧑‍🌾</span>
      <span class="flex-1">
        <span class="block text-body font-semibold text-vw-ink">{{ 'garden.actions.handover.title' | translate }}</span>
        <span class="block text-caption text-vw-muted">{{ 'garden.actions.handover.subtitle' | translate }}</span>
      </span>
      <span class="text-vw-muted">›</span>
    </button>

    <!-- Séparateur -->
    <div class="my-1 flex items-center gap-3 px-1">
      <span class="h-px flex-1 bg-vw-line"></span>
      <span class="text-caption text-vw-muted">{{ 'garden.actions.elsewhere' | translate }}</span>
      <span class="h-px flex-1 bg-vw-line"></span>
    </div>

    <!-- Ajouter une zone -->
    <button type="button" class="flex items-center gap-3 rounded-card border border-vw-line p-4 text-left" (click)="addZone()">
      <span class="flex h-11 w-11 items-center justify-center rounded-full bg-vw-surface-sunk text-title-m">📍</span>
      <span class="flex-1">
        <span class="block text-body font-semibold text-vw-ink">{{ 'garden.actions.add-zone.title' | translate }}</span>
        <span class="block text-caption text-vw-muted">{{ 'garden.actions.add-zone.subtitle' | translate }}</span>
      </span>
      <span class="text-vw-muted">›</span>
    </button>
  </div>
</vw-toast-popup>
